// extracted by mini-css-extract-plugin
export default {"audioPlayer":"styles_audioPlayer__r4XRE","inner":"styles_inner__6DrUH","isMini":"styles_isMini__Jx7bO","errMsg":"styles_errMsg__HEx3i","header":"styles_header__YGD5M"};